export const API_HOST = process.env.REACT_APP_API_HOST;

export const PRODUCT_HOST = process.env.REACT_APP_PRODUCT_HOST;

export const PUBLIC_PORTAL_HOST = process.env.REACT_APP_PUBLIC_PORTAL_HOST;

const getUrl = (resource: string) => `${API_HOST}/v1_api${resource}`;

const getUrlPrivate = (resource: string) =>
  `${API_HOST}/v1_api_private${resource}`;

export const apiRoutesMap = {
  makeReserve: {
    getRoute: (id: string | number) =>
      getUrlPrivate(`/zakazes/${id}/make-reserve`),
  },
  articles: {
    getRoute: () => getUrlPrivate(`/articles`),
  },
  article: {
    getRoute: (id: string | number) => getUrlPrivate(`/articles/${id}`),
  },
  product: {
    getRoute: (code: string | number) => getUrlPrivate(`/products/${code}`),
  },
  priceTrace: {
    getRoute: () => getUrlPrivate(`/price-trace`),
  },
  users: {
    getRoute: () => getUrlPrivate(`/users`),
  },
  user: {
    getRoute: (id: string | number) => getUrlPrivate(`/users/${id}`),
  },
  realizationDocumentsPrint: {
    getRoute: (guid: string | number) =>
      getUrl(`/realization-documents/${guid}/print-kind`),
  },
  zakazesDocumentsPrint: {
    getRoute: (guid: string | number) =>
      getUrl(`/zakazes-documents/${guid}/print-kind`),
  },
  callTasks: {
    getRoute: () => getUrlPrivate(`/tasks`),
  },
  callTask: {
    getRoute: (id: string | number) => getUrlPrivate(`/tasks/${id}`),
  },
  phoneCallRecord: {
    getRoute: (id: string | number) => getUrlPrivate(`/phonecall/${id}/record`),
  },
  reportsList: {
    getRoute: () => getUrlPrivate(`/reports`),
  },
  categories: {
    getRoute: () => getUrlPrivate(`/categories`),
  },
  types: {
    getRoute: () => getUrlPrivate(`/types`),
  },
  notifications: {
    getRoute: () => getUrlPrivate(`/notifications/messages`),
  },
  notificationsSend: {
    getRoute: () => getUrlPrivate(`/notifications/send`),
  },
  attributes: {
    getRoute: () => getUrlPrivate(`/attributes`),
  },
  category: {
    getRoute: (id: string | number) => getUrlPrivate(`/categories/${id}`),
  },
  categoryChildren: {
    getRoute: (id: string | number) =>
      getUrlPrivate(`/categories/${id}/children`),
  },
  categoriesRefresh: {
    getRoute: () => getUrlPrivate(`/categories/refresh`),
  },
  susOrders: {
    getRoute: () => getUrlPrivate(`/sus_orders`),
  },
  order: {
    getRoute: (id: string | number) => getUrlPrivate(`/orders/${id}`),
  },
  ordersReprocessPendingReview: {
    getRoute: () => getUrlPrivate(`/orders/reprocess-pending-review`),
  },
  contractorUser: {
    getRoute: (contractorId: string | number, userId: string | number) =>
      getUrlPrivate(`/contractors/${contractorId}/users/${userId}`),
  },
  promotions: {
    getRoute: () => getUrlPrivate(`/promotions`),
  },
  bitrixManagers: {
    getRoute: () => getUrlPrivate(`/bitrix/managers`),
  },
  bitrixManager: {
    getRoute: (id: string | number) => getUrlPrivate(`/bitrix/managers/${id}`),
  },
  bitrixRegionalManagers: {
    getRoute: () => getUrlPrivate(`/bitrix/regional_managers`),
  },
  bitrixResponsibleManager: {
    getRoute: () => getUrlPrivate(`/bitrix/manager`),
  },
  futurePrices: {
    getRoute: () => getUrlPrivate(`/future-prices`),
  },
  futurePrice: {
    getRoute: (id: string) => getUrlPrivate(`/future-prices/${id}`),
  },
  certificatesStaleList: {
    getRoute: () => getUrlPrivate(`/certificates/stale-list`),
  },
  certificatesStaleListExport: {
    getRoute: () => getUrlPrivate(`/certificates/stale-list/export.xlsx`),
  },
  certificates: {
    getRoute: (code: string | number) => getUrlPrivate(`/certificates/${code}`),
  },
  certificatesVerify: {
    getRoute: (code: string | number) =>
      getUrlPrivate(`/certificates/${code}/verify`),
  },
};

export const apiPublicRoutesMap = {
  categories: {
    getRoute: () => getUrl(`/categories`),
  },
  category: {
    getRoute: (id: string | number) => getUrl(`/categories/${id}`),
  },
  searchProductsByBarcodes: {
    getRoute: () => getUrl(`/products/search`),
  },
  smartTask: {
    getRoute: () => getUrl(`/promotions/smart`),
  },
  categoriesMissingProducts: {
    getRoute: () => getUrl(`/categories/missing_products`),
  },
};
